import { useSupplierId, useSupporterId } from "@/utils/roles";
import { Flex } from "@givenwell/components";
import { linkOptions } from "@tanstack/react-router";
import { ReactNode } from "react";

export function FixedSidebar({ children }: { children?: ReactNode }) {
  const supplierId = useSupplierId();
  const supporterId = useSupporterId();

  const homeLinkOptions = supplierId
    ? linkOptions({
        to: "/supplier/$supplierId",
        params: { supplierId },
      })
    : supporterId
      ? linkOptions({
          to: "/supporter/$supporterId",
          params: { supporterId },
        })
      : linkOptions({ to: "/admin" });

  return (
    <Flex
      css={{
        w: 230,
        maxW: 230,
        minW: 230,
        position: "fixed",
        top: 0,
        // bottom: "var(--safe-area-inset-bottom)",
        bottom: 0,
        left: 0,
        // px: 16,
        // pl: 22,
        gap: 0,

        d: "none",
        "@md": {
          flexDir: "column",
          d: "flex",
          overflowY: "hidden",
        },
      }}
    >
      {children}
    </Flex>
  );
}
